module.exports = __webpack_public_path__ + "static/media/egg_box_5.cd02299c.png";